<template>
  <Map
    :latitude="data.geolocation.lat"
    :longitude="data.geolocation.lng"
    :link="data.link.uri.path"
  />
</template>

<script setup lang="ts">
import { type ParagraphMapFragment } from '#graphql-operations'
defineProps<{
  data: ParagraphMapFragment
}>()
</script>
